import React, { useState, useEffect } from "react";
import ChevronUpIcon from "../../icons/chevronUp.icon";
import { ShoppingCartIcon } from "../../icons/shoppingCart.icon";
import PhoneIcon from "../../icons/phone.icon";
import { useRouter } from "next/router";
import WhatsappIcon from "../../icons/whatsapp.icon";

const FloatingIcons = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    handleResize();

    // Add listener for window resize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const headerEntry = entries[0];
        // Reverse the visibility logic - hide when header is visible
        setIsVisible(!headerEntry.isIntersecting);
      },
      {
        // Adjust rootMargin to be more sensitive to header visibility
        rootMargin: "0px",
        threshold: 0,
      }
    );

    const header = document.querySelector("header");

    if (header) {
      observer.observe(header);
    }

    return () => {
      if (header) {
        observer.unobserve(header);
      }
      observer.disconnect();
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleCartClick = () => {
    router.push("/cart");
  };

  const baseButtonClasses = `
    w-12 h-12 md:w-16 md:h-16
    rounded-full 
    flex items-center justify-center 
    text-white 
    shadow-lg hover:shadow-xl 
    transform hover:scale-110 
    transition-all duration-500 ease-in-out
    ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"}
  `;

  return (
    <div className="fixed bottom-4 md:bottom-8 right-4 md:right-8 z-50 flex flex-col gap-2 md:gap-4">
      <button
        onClick={() => window.open("https://wa.me/85257448696", "_blank")}
        className={`${baseButtonClasses} `}
        aria-label="Contact on WhatsApp"
      >
        <WhatsappIcon className="w-12 h-12 md:w-16 md:h-16" />
      </button>

      <button onClick={handleCartClick} className={`${baseButtonClasses} bg-guru-milk-chocolate`} aria-label="View shopping cart">
        <ShoppingCartIcon className="w-6 h-6 md:w-8 md:h-8" />
      </button>

      <button onClick={scrollToTop} className={`${baseButtonClasses} bg-guru-milk-chocolate`} aria-label="Scroll to top">
        <ChevronUpIcon className="w-6 h-6 md:w-8 md:h-8" />
      </button>
    </div>
  );
};

export default FloatingIcons;
